import ptBR from 'date-fns/locale/pt-BR';
import { Col, Form, ListGroup, Row } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import MaskedInput from 'react-text-mask';

const DateTimePickerComponent = ({ value, onChange, applyCustomStyles }) => {
  const handleDateChange = date => {
    if (!date) {
      onChange(null);
      return;
    }

    // Ajusta para o fuso horário local
    const currentTime = value ? value.split('T')[1] : '00:00';
    const [hours, minutes] = currentTime.split(':');

    // Define a data mantendo o horário local
    const selectedDate = new Date(date);
    selectedDate.setHours(parseInt(hours, 10), parseInt(minutes, 10), 0, 0);

    // Formata para ISO string e ajusta o fuso
    const isoDate = new Date(
      selectedDate.getTime() - selectedDate.getTimezoneOffset() * 60000
    )
      .toISOString()
      .slice(0, 16);

    onChange(isoDate);
  };

  const handleTimeChange = e => {
    const timeValue = e.target.value || '00:00';

    // Validate time format
    const timeRegex = /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/;
    if (!timeRegex.test(timeValue)) {
      return;
    }

    if (!value) {
      // Se não houver data selecionada, usa a data atual
      const now = new Date();
      const [hours, minutes] = timeValue.split(':');
      now.setHours(parseInt(hours, 10), parseInt(minutes, 10), 0, 0);
      const isoDate = new Date(now.getTime() - now.getTimezoneOffset() * 60000)
        .toISOString()
        .slice(0, 16);
      onChange(isoDate);
      return;
    }

    // Se já existe uma data, mantém ela e só atualiza o horário
    const currentDate = new Date(value);
    const [hours, minutes] = timeValue.split(':');
    currentDate.setHours(parseInt(hours, 10), parseInt(minutes, 10), 0, 0);
    const isoDate = new Date(
      currentDate.getTime() - currentDate.getTimezoneOffset() * 60000
    )
      .toISOString()
      .slice(0, 16);
    onChange(isoDate);
  };

  const handleToday = () => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    handleDateChange(today);
  };
  const handleTomorrow = () => {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    tomorrow.setHours(0, 0, 0, 0);
    handleDateChange(tomorrow);
  };

  const handleNoDate = () => {
    onChange(null);
  };

  return (
    <div
      className={`date-picker-wrapper ${
        applyCustomStyles ? 'custom-styles' : ''
      }`}
    >
      <Row className="align-items-center gx-2 gy-0">
        <Col md={8}>
          <DatePicker
            selected={value ? new Date(value) : null}
            onChange={handleDateChange}
            formatWeekDay={day => day.slice(0, 3)}
            locale={ptBR}
            dateFormat="dd/MM/yyyy"
            calendarContainer={({ children }) => (
              <div className="react-datepicker react-datepicker__predefined-ranges">
                <ListGroup variant="flush" className="react-datepicker__ranges">
                  <ListGroup.Item action onClick={handleToday}>
                    Hoje
                  </ListGroup.Item>
                  <ListGroup.Item action onClick={handleTomorrow}>
                    Amanhã
                  </ListGroup.Item>
                  <ListGroup.Item action onClick={handleNoDate}>
                    Sem data
                  </ListGroup.Item>
                </ListGroup>
                {children}
              </div>
            )}
            className="form-control"
          />
        </Col>

        <Col>
          <MaskedInput
            mask={[/[0-9]/, /\d/, ':', /\d/, /\d/]}
            placeholder="00:00"
            guide={false}
            value={
              value &&
              new Date(value).toLocaleTimeString('pt-BR', {
                hour: '2-digit',
                minute: '2-digit',
                hour12: false
              })
            }
            onChange={handleTimeChange}
            render={(ref, props) => <Form.Control ref={ref} {...props} />}
          />
        </Col>
      </Row>
    </div>
  );
};

export default DateTimePickerComponent;
